/* eslint-disable prettier/prettier */
import toast from "react-hot-toast";
import { GetGaleria, InsertGaleria, EliminarGaleria } from "../apis";
import axios from "axios";

import { store } from "../store";

import {
  setGaleria,
  setAddGaleria,
  removeGaleria,
  setisloadingGaleria,
} from "../solicitudes/solicitudesSlice";

export function ObtenerGaleria(dispatch, idSolicitud) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .get(GetGaleria().concat("?idSolicitud=").concat(idSolicitud), {
      ...header,
    })
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setGaleria(response.data.data));
        dispatch(setisloadingGaleria(false));
      } else {
      }
    })
    .catch((error) => {});
}

export const ObtenerGaleriaExcel = async (idSolicitud) => {
  const token = store.getState().login.token;
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      GetGaleria().concat("?idSolicitud=").concat(idSolicitud),
      header
    );
    if (response.data.code === "Ok") {
      return response.data.data;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export function AddGaleria(dispatch, data) {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");
  const header = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .post(InsertGaleria(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        toast.success("Imagen subida con exito");
        dispatch(setAddGaleria(response.data.data));
      } else {
        toast.error("Ocurrio un error ");
      }
    })
    .catch((error) => {
      toast.remove(id);

      toast.error("Ocurrio un error ");
    });
}

export function DelGaleria(dispatch, data) {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  let formData = {
    ...data,
    usuario: usuario?.username,
  };

  axios
    .post(EliminarGaleria(), formData, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(removeGaleria(formData.idGaleria));
        toast.success("Elemento eliminado con éxito ");
      } else {
        toast.error("Ocurrio un error ");
      }
    })
    .catch((error) => {
      toast.remove(id);

      toast.error("Ocurrio un error ");
    });
}
